import React, { useState } from 'react';
import BrushIcon from '@mui/icons-material/Brush';

import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import MessageModal from '../message-modal/MessageModal';

interface NotesEditButtonProps {
  /** Base id used for click tracking (Google Analytics). */
  id?: string;
  onEdit: () => void;
  onDelete: () => void;
}

export const NotesEditButton = ({ id, onEdit, onDelete }: NotesEditButtonProps) => {
  const { t } = useTranslation();
  const [deleteMessageModalOpen, setDeleteMessageModalOpen] = useState(false);

  return (
    <>
      {deleteMessageModalOpen && (
        <MessageModal
          open={deleteMessageModalOpen}
          modalTitle={t('messages.deleteNote')}
          modalMessage={t('messages.deleteNoteDialog')}
          actionButtonText={t('buttons.goBack')}
          actionButtonFn={() => setDeleteMessageModalOpen(false)}
          goBackButtonText={t('buttons.delete')}
          onDismiss={() => setDeleteMessageModalOpen(false)}
          onClose={() => {
            onDelete();
          }}
        />
      )}
      <Tooltip title={t('buttons.edit')} placement='top' arrow>
        <IconButton
          id={`${id ?? 'notesEditButton'}EditIconBtn`}
          size='small'
          onClick={() => {
            onEdit();
          }}
        >
          <BrushIcon id={`${id ?? 'notesEditButton'}EditIconBtnBrushIcon`} fontSize='small' />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('buttons.delete')} placement='top' arrow>
        <IconButton
          id={`${id ?? 'notesEditButton'}DeleteIconBtn`}
          size='small'
          onClick={() => {
            setDeleteMessageModalOpen(true);
          }}
        >
          <DeleteIcon id={`${id ?? 'notesEditButton'}DeleteIconBtnDeleteIcon`} fontSize='small' />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default NotesEditButton;
